import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { SubHeaderWrapper, StyledTabPane, StyledSubMenu } from './styled'
import { getUserRole } from '../../../selectors/user'
import {
  getSchoolAdminSettingsAccess,
  getEnableOneRosterSync,
} from '../../../../DistrictPolicy/ducks'
import { createTabBarRenderer, SETTING_SUB_HEADER_FROM } from './renderTabBar'

class AdminSubHeader extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    active: PropTypes.object.isRequired,
  }

  componentDidMount() {
    const { history } = this.props
    const { state } = history.location

    if (state?.from === SETTING_SUB_HEADER_FROM && history.action !== 'POP') {
      const activeTabElement = document.querySelector(
        '.ant-tabs-tab[aria-selected="true"]'
      )
      if (activeTabElement) {
        activeTabElement.focus()
      }
    }
    // set tabindex to -1 to prevent focus on tabs bar to avoid additional focus stop
    const bar = document.querySelector('.ant-tabs-bar')
    if (bar) bar.setAttribute('tabindex', '-1')
  }

  onSubTab = (key, e) => {
    const { history } = this.props
    switch (key) {
      case 'District Policies':
        history.push(`/author/settings/districtpolicies`, {
          from: SETTING_SUB_HEADER_FROM,
        })
        return
      case 'School Policies':
        history.push(`/author/settings/schoolpolicies`, {
          from: SETTING_SUB_HEADER_FROM,
        })
        return
      case 'Test Settings':
        history.push(`/author/settings/testsettings`, {
          from: SETTING_SUB_HEADER_FROM,
        })
        return
      case 'Term':
        history.push(`/author/settings/term`, { from: SETTING_SUB_HEADER_FROM })
        return
      case 'Performance Bands':
        history.push(`/author/settings/performance-bands`, {
          from: SETTING_SUB_HEADER_FROM,
        })
        return
      case 'Standards Proficiency':
        history.push(`/author/settings/standards-proficiency`, {
          from: SETTING_SUB_HEADER_FROM,
        })
        return
      case 'Import Sis Data':
        history.push(`/author/settings/roster-import`, {
          from: SETTING_SUB_HEADER_FROM,
        })
        return
      case 'Interested Standards':
        history.push(`/author/settings/interested-standards`, {
          from: SETTING_SUB_HEADER_FROM,
        })
        return
      default:
        return
    }
  }

  render() {
    const {
      active,
      role,
      schoolLevelAdminSettings,
      enableOneRosterSync,
    } = this.props
    return (
      <SubHeaderWrapper>
        {active.mainMenu === 'Settings' && (
          <StyledSubMenu
            mode="horizontal"
            defaultActiveKey={active.subMenu}
            onTabClick={this.onSubTab}
            renderTabBar={createTabBarRenderer(active.subMenu)}
          >
            {role === 'district-admin' ? (
              <StyledTabPane tab="District Policies" key="District Policies" />
            ) : null}
            {role === 'school-admin' && schoolLevelAdminSettings ? (
              <StyledTabPane tab="School Policies" key="School Policies" />
            ) : null}
            <StyledTabPane tab="Test Settings" key="Test Settings" />
            <StyledTabPane tab="Term" key="Term" />
            {role === 'district-admin' ? (
              <StyledTabPane
                tab="District Standards"
                key="Interested Standards"
              />
            ) : null}
            {role === 'school-admin' ? (
              <StyledTabPane
                tab="School Standards"
                key="Interested Standards"
              />
            ) : null}
            <StyledTabPane tab="Performance Bands" key="Performance Bands" />
            <StyledTabPane
              tab="Standards Proficiency"
              key="Standards Proficiency"
            />
            {role === 'district-admin' && enableOneRosterSync ? (
              <StyledTabPane tab="Import Sis Data" key="Import Sis Data" />
            ) : null}
          </StyledSubMenu>
        )}
      </SubHeaderWrapper>
    )
  }
}

export default connect(
  (state) => ({
    role: getUserRole(state),
    schoolLevelAdminSettings: getSchoolAdminSettingsAccess(state),
    enableOneRosterSync: getEnableOneRosterSync(state),
  }),
  {}
)(AdminSubHeader)
